import React, { useState, useEffect } from 'react'
import { checkToken, codeRequest } from '../api'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'

export function TokenDialog() {
  const [alert, setAlert] = useState(false)
  const [timer, setTimer] = useState({} as NodeJS.Timeout)
  const warningTime: number = 600000 //10min

  useEffect(() => {
    if (typeof timer === 'object') {
      const newTimer = setInterval(() => {
        if (!checkToken() || checkToken() <= warningTime) {
          setAlert(true)
          clearInterval(newTimer)
        }
      }, 20000)
      setTimer(newTimer)
    }
  }, [timer])

  function redirect() {
    setAlert(false)
    codeRequest()
  }

  function close() {
    setAlert(false)
  }

  if (alert) {
    return (
      <Dialog open={alert} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>{'Token Expiration'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Der Token läuft demnächst ab. Bitte beenden sie ihre Arbeit oder erneuern sie die Token.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close} color='secondary'>
            Close
          </Button>
          <Button onClick={redirect} color='primary' autoFocus>
            Refresh
          </Button>
        </DialogActions>
      </Dialog>
    )
  } else {
    return null
  }
}

export default TokenDialog
